import { colors } from '@flowwai-frontend/shared/style-guide'

const pmuPortalTheme = {
   light: {
      pmuUserHeader: {
         defaultBorderColor: 'border-gray-300',
         headerTextColor: 'text-gray-900',
         refreshIconColor: '!bg-base-white'
      },
      pmuUserBody: {
         documentPreviewBgColor: 'bg-gray-600',
         whiteHoverBgColor: 'hover:bg-white',
         defaultBorderColor: 'border-gray-300',
         dividerColor: 'border-gray-200',
         headerTextColor: 'text-gray-900',
         settingCardTitleColor: 'text-gray-800',
         userNameCardBgColor: 'bg-gray-50',
         labelColor: 'text-gray-500',
         descriptionColor: 'text-gray-600',
         userIconColorBg: 'bg-gray-100',
         alertIconFillColor: colors['error-100'],
         alertIconStrokeColor: colors['error-50'],
         iconColor: colors['gray-600'],
         textColor: 'text-gray-700',
         baseWhiteColor: 'bg-base-white',
         titleColor: 'text-gray-900',
         subtitleColor: 'text-gray-600',
         avatarBackgroundColor: 'bg-purple-100',
         avatarTextColor: 'text-purple-600',
         statusBadgeBackgroundColor: 'bg-green-100',
         statusDotColor: 'bg-green-500',
         statusTextColor: 'text-green-800',
         labelTextColor: 'text-gray-900',
         errorTextColor: 'text-error-500',
         resetOtpCounter: {
            loadingColor: colors['error-700'],
            loadingTextColor: 'text-error-700'
         },
         actionIcon: {
            transferUserIconColor: colors['lime-600'],
            initiateLeaveIconColor: colors['purple-600'],
            deactivateUserIconColor: colors['red-600'],
            endLeaveIconColor: colors['warning-600'],
            relieveOfficerIconColor: colors['pink-600'],
            updateUserIconColor: colors['cyan-600'],
            resetOtpIconColor: colors['warning-600'],
            transferUserBgColor: 'bg-lime-100',
            initiateLeaveBgColor: 'bg-purple-100',
            deactivateUserBgColor: 'bg-red-100',
            endLeaveBgColor: 'bg-warning-100',
            relieveOfficerBgColor: 'bg-pink-100',
            updateUserBgColor: 'bg-cyan-100',
            createOfficerBgColor: 'bg-success-100',
            resetOtpBgColor: 'bg-warning-100'
         },
         createOfficerCard: {
            iconBgColor: 'bg-success-100',
            iconColor: colors['success-600'],
            titleColor: 'text-gray-800'
         },
         loginAction: {
            textColor: 'text-gray-700',
            dateTimeColor: 'text-gray-800'
         },
         notifyUserModal: {
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-600',
            userIconColorBg: 'bg-primary-100'
         },
         assignMandal: {
            checkIconColor: colors['base-white'],
            checkboxSelectedBgColor: 'bg-primary-600',
            checkboxSelectedBorderColor: 'border-primary-600',
            defaultBorderColor: 'border-gray-300',
            labelColor: 'text-gray-600'
         },
         pmuActionHeader: {
            backButtonColor: 'text-primary-600',
            backButtonHoverColor: 'hover:text-primary-700',
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-600'
         },
         radioButton: {
            selectedContainerBg: 'bg-primary-25',
            selectedContainerBorder: 'border-primary-600',
            unselectedContainerBg: 'bg-base-white',
            unselectedContainerBorder: 'border-gray-300',
            selectedIconColor: 'bg-primary-600',
            selectedIconInnerColor: 'bg-base-white',
            unselectedIconColor: 'border-gray-300',
            titleTextColor: 'text-gray-700'
         },
         requiredIconColor: 'text-error-700',
         officerRadioGroup: {
            labelColor: 'text-gray-700',
            separatorColor: 'text-gray-500',
            requiredIconColor: 'text-error-700'
         },
         officerActionNote: {
            noteBackgroundColor: 'bg-warning-100',
            noteBorderColor: 'border-warning-300',
            textColor: 'text-gray-700'
         }
      },
      tdrManagementLogsHeader: {
         headerBgColor: 'bg-base-white',
         defaultBorderColor: 'border-gray-300',
         headerTextColor: 'text-gray-900'
      },
      pmuUserLogs: {
         bgColor: 'bg-gray-100',
         pmuOfficerLogCard: {
            borderColor: 'border-gray-300',
            titleTextColor: 'text-gray-800',
            timestampTextColor: 'text-gray-600',
            chevronColor: 'text-gray-500',
            descriptionBackgroundColor: 'bg-gray-50',
            descriptionTextColor: 'text-gray-700'
         },
         pmuUserLogsHeader: {
            defaultBorderColor: 'border-gray-300',
            headerTextColor: 'text-gray-900',
            refreshIconColor: '!bg-base-white',
            closeIconColor: colors['gray-500'],
            filterButtonStyle: 'border-primary-600'
         },
         filterConditionPills: {
            borderColor: 'border-gray-300',
            iconColors: colors['primary-600'],
            propertyIconColor: colors['primary-600'],
            tooltipArrowColor: colors['gray-900'],
            addFilterButton: {
               iconColor: colors['primary-600'],
               textColor: 'text-primary-700',
               borderColor: 'border-primary-600'
            },
            clearFilterButton: {
               iconColor: colors['gray-600'],
               textColor: 'text-gray-600'
            }
         },
         pmuUserLogCard: {
            dividerColor: 'border-gray-200',
            titleColor: 'text-gray-900',
            textColor: 'text-gray-800',
            labelColor: 'text-gray-600',
            reasonTextColor: 'text-gray-800',
            phoneNumberIconColor: colors['primary-600'],
            baseWhiteColor: 'bg-base-white',
            defaultBorderColor: 'border-gray-300',
            transferUserCard: {
               iconBgColor: 'bg-lime-200',
               iconColor: colors['lime-700']
            },
            deactivateUserCard: {
               iconBgColor: 'bg-red-200',
               iconColor: colors['red-700']
            },
            userDetailsUpdateCard: {
               iconBgColor: 'bg-primary-200',
               iconColor: colors['primary-500']
            },
            resetOtpCard: {
               iconBgColor: 'bg-warning-200',
               iconColor: colors['warning-600']
            },
            userLeaveCard: {
               leaveStartIconBgColor: 'bg-purple-200',
               leaveStartIconColor: colors['purple-600'],
               leaveEndIconBgColor: 'bg-warning-200',
               leaveEndIconColor: colors['warning-600'],
               iconBgColor: 'bg-warning-500',
               iconColor: colors['base-white']
            }
         },
         officerLogs: {
            defaultBorderColor: 'border-gray-300',
            titleColor: 'text-gray-700',
            descriptionColor: 'text-gray-500'
         }
      },
      resetOtpCounter: {
         loadingColor: colors['error-700'],
         loadingTextColor: 'text-error-700'
      },
      applicationManagementLogsHeader: {
         headerBgColor: 'bg-base-white',
         defaultBorderColor: 'border-gray-300',
         headerTextColor: 'text-gray-900'
      },
      applicationManagementLogCard: {
         dividerColor: 'border-gray-200',
         titleColor: 'text-gray-900',
         textColor: 'text-gray-800',
         labelColor: 'text-gray-600',
         baseWhiteColor: 'bg-base-white',
         taskShortfallCard: {
            iconBgColor: 'bg-primary-100',
            iconColor: colors['primary-600']
         }
      },
      applicationManagementActionIcon: {
         taskShortfallBgColor: 'bg-warning-200',
         taskShortfallIconColor: colors['warning-600']
      },
      applicationManagement: {
         header: {
            defaultBorderColor: 'border-gray-300',
            headerTextColor: 'text-gray-900'
         },
         searchBody: {
            titleColor: 'text-gray-700'
         },
         searchAsyncComboBox: {
            optionTextColor: 'text-gray-900',
            optionHoverBgColor: 'hover:bg-gray-100',
            iconStrokeColor: colors['gray-600']
         },
         actionButton: {
            textColor: 'text-gray-700'
         },
         applicationManagementADVHeader: {
            notSectionTitleColor: 'text-warning-700',
            notSectionBgColor: 'bg-warning-25',
            notSectionBorderColor: 'border-warning-300',
            labelColor: 'text-gray-600',
            valueColor: 'text-gray-800',
            refreshIconColor: colors['gray-700'],
            iconColor: colors['warning-700']
         }
      },
      tdrManagement: {
         onHoldTdrCertificate: {
            titleColor: 'text-gray-900',
            headerBorderColor: 'border-gray-300',
            containerBgColor: 'bg-gray-50'
         },
         releaseTdrCertificate: {
            titleColor: 'text-gray-900',
            headerBorderColor: 'border-gray-300'
         },
         releaseCertificateFormModal: {
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-500',
            borderColor: 'border-gray-300',
            containerBgColor: 'bg-white',
            requiredIconColor: 'text-error-700'
         },
         otpVerificationCard: {
            checkIconBgColor: 'bg-success-100',
            checkIconColor: colors['success-600'],
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-600',
            mobileNumberColor: 'text-gray-900',
            errorMessageColor: 'text-error-500',
            resendButtonColor: 'text-primary-600'
         },
         onHoldCertificateForm: {
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-500',
            borderColor: 'border-gray-200',
            containerBgColor: 'bg-white',
            detailsBorderColor: 'border-gray-200',
            detailsBgColor: 'bg-gray-50',
            detailLabelColor: 'text-gray-500',
            detailValueColor: 'text-gray-700',
            certificateDetailDividerColor: 'bg-gray-400',
            viewLedgerColor: 'text-primary-600',
            helperTextColor: 'text-gray-500',
            requiredIconColor: 'text-error-700',
            checkboxLabelColor: 'text-gray-700'
         },
         tdrManagementFileUploader: {
            labelColor: 'text-gray-700',
            errorTextColor: 'text-error-500'
         }
      },
      taskShortfall: {
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-500',
         borderColor: 'border-gray-200',
         containerBgColor: 'bg-white',
         requiredIconColor: 'text-error-700',
         fileUploaderLabelColor: 'text-gray-700',
         fileUploaderErrorTextColor: 'text-error-500'
      },
      tdrManagementLogDetailsSidePane: {
         defaultBorderColor: 'border-gray-300',
         defaultTextColor: 'text-gray-800',
         headerTextColor: 'text-gray-900',
         sectionTitleColor: 'text-gray-700',
         noContentColor: 'text-gray-500'
      },
      tdrManagementLogsFilterSidepane: {
         defaultBorderColor: 'border-gray-300',
         headerTextColor: 'text-gray-900',
         closeIconColor: colors['gray-500']
      },
      applicationManagementLogsFilterSidepane: {
         defaultBorderColor: 'border-gray-300',
         headerTextColor: 'text-gray-900',
         closeIconColor: colors['gray-500']
      }
   },
   dark: {}
}

export default pmuPortalTheme
